<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalMap"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-width-map"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div style="text-transform: uppercase" class="data_text">
              {{ titleNetwork }}
              <!-- <h6 style="text-transform: capitalize;">{{ titleNetwork }}</h6> -->
            </div>
            <!-- <div class="card_title_2">Last Update: {{ lastUpdate }}</div> -->
          </div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div
            style="cursor: pointer"
            v-for="(item, id) in dataDetail"
            :key="id"
            :style="
              item.cityId === undefined
                ? 'background-color: #f6f6f6; padding: 2%'
                : 'padding: 2%'
            "
            class="m-b-20 d-flex align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <div
                :style="item.cityId === undefined ? 'color:#4D4D4D' : ''"
                :class="item.cityId === undefined ? 'card_title_1' : ''"
              >
                {{ item.cityName }}
              </div>
            </div>
            <div
              :style="item.cityId === undefined ? 'color:#4D4D4D' : ''"
              :class="item.cityId === undefined ? 'card_title_1' : ''"
            >
              {{ item.value }} %
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalNetwortMapChartVue
      :showModal="modalMap.show"
      :dataNetworkDetail="dataNetworkDetail"
      :titleNetwork="titleNetworks"
      @closeModal="onCloseModalMap"
    ></ModalNetwortMapChartVue>
  </div>
</template>

<script>
import ModalNetwortMapChartVue from "./ModalNetwortMapChart.vue";

import DistributionService from "@/services/distribution/distribution";
const apiDistribution = DistributionService.build();
export default {
  components: { ModalNetwortMapChartVue },
  props: ["showModal", "dataNetwork", "titleNetwork", "idDetailMap"],
  data() {
    return {
      lastUpdate: "",
      titleNetworks: "",
      dataNetworkDetail: [],
      modalMap: {
        show: false,
        load: false,
      },
      modal: null,
      series: [],
      chartOptions: {},
      dataDetail: [],
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalMap);
  },

  methods: {
    async getDataDistributionNetworkMapDetail() {
      let param = Object.assign({
        metricId: this.idDetailMap,
        provinceId: this.dataNetwork.provinceId,
      });
      const res = await apiDistribution.getDataDistributionNetworkMapDetail(
        param
      );
      this.lastUpdate = res.data.lastUpdate;
      const data = res.data.data;
      data.push({
        cityName: this.dataNetwork.provinceName,
        value: this.dataNetwork.value,
      });
      const reversedObjects = data.reverse();
      this.dataDetail = reversedObjects;
    },
    onCloseModalMap(value) {
      this.modalMap.show = value;
    },
    detailChart(item) {
      this.dataNetworkDetail = item;
      // this.titleNetworks = item.cityName;
      this.titleNetworks = this.dataNetwork.provinceName;
      this.modalMap.show = true;
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
  },

  watch: {
    async showModal() {
      if (this.showModal) {
        this.getDataDistributionNetworkMapDetail();
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom_header {
  padding: 1rem 1rem 0rem 1rem;
  border-bottom: unset;

  .custom_header_content {
    width: 100%;
    position: relative;

    .close_btn {
      position: absolute;
      right: 0;
      z-index: 999;
    }

    .tahun_text {
      font-size: 20px;
      font-weight: 400;
      line-height: 23px;
    }

    .judul_text {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
    }
  }
}

.custom-modal-width {
  max-width: 564px;
  width: 100%;
}

.tabs {
  color: #838383;
  font-size: 14px;
  padding: 5px;
  cursor: pointer;
}

.tabs_active {
  color: #00a3e9;
  border-bottom: 3px solid #00a3e9;
}

.custom_pb {
  background: unset !important;
  height: 8px;
}
.modal-dialog-scrollable .modal-content {
  max-height: 50% !important;
}
::-webkit-scrollbar-track {
  background: white;
}
/* Change color of scrollbar track */
.modal-body::-webkit-scrollbar {
  width: 12px; /* Set width of scrollbar */
}
.modal-body::-webkit-scrollbar-track {
  background-color: #ffffff; /* Set color of track */
}
</style>
